import React from 'react'
import { matchPath } from 'react-router'
import { useLocation } from 'react-router'
import { sendToNative } from '@mobi/web-native-comms/web'
import { AppRoutes } from '@core/AppRoutes'
import { isRaceRoute } from '@core/State/Navigation/helpers/isRaceRoute'
import type { NavigationTabs } from '../types'

export const useActiveTab = (shouldUseLegacyTabNavigation: boolean) => {
  const { pathname } = useLocation()

  const activeTab = getActiveTabName(pathname)

  React.useEffect(() => {
    if (!shouldUseLegacyTabNavigation) return
    if (activeTab === 'BetLoop') return
    sendToNative('SET_ACTIVE_TAB', { activeTab })
  }, [activeTab, shouldUseLegacyTabNavigation])

  return activeTab
}

// =============
// Local Helpers
// =============

function getActiveTabName(pathname: string): NavigationTabs {
  const homePageMatch = matchPath(AppRoutes.Home, pathname)
  if (homePageMatch?.pathname === '/') {
    return 'Home'
  }

  if (
    matchPath(AppRoutes.SportsRoot + '/*', pathname) ||
    matchPath(AppRoutes.Sports + '/*', pathname)
  ) {
    return 'Sports'
  }

  if (isRaceRoute(pathname)) {
    return 'Races'
  }

  if (pathname === AppRoutes.RaceCardSky) {
    return 'SkyRacing'
  }

  if (matchPath(AppRoutes.BetLoop + '/*', pathname)) {
    return 'BetLoop'
  }

  return undefined
}
